/**
 * useWeeklyEnergy Hook
 *
 * Fetches 336 half-hourly energy slots (7 days) via the
 * get_weekly_energy_slots RPC.
 */

import { useState, useEffect, useCallback } from 'react'
import { supabase } from '@/supabase-client'

export function useWeeklyEnergy(startDate, refreshKey) {
  const [data, setData] = useState([])
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState(null)

  const fetch = useCallback(async () => {
    if (!startDate) return

    setIsLoading(true)
    setError(null)

    try {
      const { data: slots, error: rpcError } = await supabase.rpc(
        'get_weekly_energy_slots',
        { p_start: startDate }
      )

      if (rpcError) throw rpcError

      setData(slots || [])
    } catch (err) {
      console.error('[useWeeklyEnergy] Failed:', err)
      setError(err.message)
      setData([])
    } finally {
      setIsLoading(false)
    }
  }, [startDate, refreshKey])

  useEffect(() => {
    fetch()
  }, [fetch])

  return { data, isLoading, error, refresh: fetch }
}

export default useWeeklyEnergy
